import { useEffect } from 'react';
import { useKeyPress } from './useKeyPress';
export function useCloseOnEscape(closeCallback) {
    const [escapeKeyPressed, wasHandled] = useKeyPress('Escape');
    useEffect(() => {
        if (escapeKeyPressed) {
            closeCallback();
            wasHandled();
        }
    }, [closeCallback, escapeKeyPressed, wasHandled]);
}
